module.exports = __webpack_public_path__ + "fonts/open-sauce-sans-latin-500-normal.dd75310.woff";